import { useEffect } from 'react';
import { releaseRailOpen, requestRailOpen } from 'components/FilterPanel/useFilterRailCollapse';

/**
 * Hold the filter rail open while the builder is in focus mode, then release
 * it on the way out (Asana 1219902279124885 Decision 1).
 *
 * The shape of useCollapseNavForPage: the request is transient and never
 * writes the filter_rail_collapsed preference, so leaving focus (or the page)
 * puts the user's stored choice back in force on the next surface. A manual
 * fold while held is honoured for the rest of the hold by the hook itself.
 *
 * Pass `held: false` on the stepped (phone) layout, where no rail is mounted.
 */
export const useRailOpenWhileFocused = (held: boolean) => {
  useEffect(() => {
    if (!held) return undefined;
    requestRailOpen();
    return releaseRailOpen;
  }, [held]);
};

export default useRailOpenWhileFocused;
